import { computed, inject } from '@angular/core';
import { signalStore, withComputed, withFeature, withProps, withState } from '@ngrx/signals';
import { UserControllerService } from '@api/core';
import { NotificationService } from '@shared/services/notifications/notifications.service';
import { useAccounts } from '@shared/store/features/accounts.feature';
import { useBalances } from '@shared/store/features/balances.feature';
import { useReportingCodes } from '@shared/store/features/reporting-codes.feature';
import { useUserSettings } from '@shared/store/features/user-settings.feature';
import { useUsers } from '@shared/store/features/users.feature';
import { useAppVersion } from './features/app-version.feature';
import { useCurrentUser } from './features/current-user.feature';
import { useCustomCommissions } from './features/custom-commissions.feature';
import { useInfo } from './features/info.feature';
import { useSystemStatus } from './features/system-status.feature';
import { useRoutePresets } from './features/route-presets.feature';
import { useSharedSettings } from './features/shared-settings/shared-settings.feature';
import { keyBy } from 'lodash';

const MAX_ORDER_INDEX = 999;

export const SharedStore = signalStore(
  { providedIn: 'root' },
  withState({}),
  withProps(() => ({
    _notificationService: inject(NotificationService),
    _usersService: inject(UserControllerService),
  })),
  withFeature(useCurrentUser),
  withFeature(useAccounts),
  withFeature(useSharedSettings),
  withFeature(useUsers),
  withFeature(useReportingCodes),
  withFeature(useRoutePresets),
  withFeature(useBalances),
  withFeature(useCustomCommissions),
  withFeature(useUserSettings),
  withFeature(useInfo),
  withFeature(useSystemStatus),
  withFeature(useAppVersion),
  withComputed(store => {
    const lpsWithOrder = computed(() => {
      const lpsOrder = store.lpsOrder();

      return store.liquidityProviders().map(lp => ({
        ...lp,
        order: lpsOrder[lp.id!] ?? MAX_ORDER_INDEX,
      }));
    });

    const lpsWithOrderMap = computed(() => keyBy(lpsWithOrder(), 'id'));

    return {
      lpsWithOrder,
      lpsWithOrderMap,
    };
  }),
);
